/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Invitation_RevokedInputs */

const en_us2_group_invitation_revoked = /** @type {(inputs: Group_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invitation was cancelled.`)
};

const pt_br2_group_invitation_revoked = /** @type {(inputs: Group_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este convite foi cancelado.`)
};

const pt_pt2_group_invitation_revoked = /** @type {(inputs: Group_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este convite foi cancelado.`)
};

/** @type {(inputs: Group_Invitation_RevokedInputs) => LocalizedString} */
const es_419_group_invitation_revoked = en_us2_group_invitation_revoked;

/** @type {(inputs: Group_Invitation_RevokedInputs) => LocalizedString} */
const fr_fr2_group_invitation_revoked = en_us2_group_invitation_revoked;

/** @type {(inputs: Group_Invitation_RevokedInputs) => LocalizedString} */
const de_de2_group_invitation_revoked = en_us2_group_invitation_revoked;

/** @type {(inputs: Group_Invitation_RevokedInputs) => LocalizedString} */
const it_it2_group_invitation_revoked = en_us2_group_invitation_revoked;

/**
* | output |
* | --- |
* | "This invitation was cancelled." |
*
* @param {Group_Invitation_RevokedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_invitation_revoked = /** @type {((inputs?: Group_Invitation_RevokedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Invitation_RevokedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_invitation_revoked(inputs)
	if (locale === "es-419") return es_419_group_invitation_revoked(inputs)
	if (locale === "pt-PT") return pt_pt2_group_invitation_revoked(inputs)
	if (locale === "fr-FR") return fr_fr2_group_invitation_revoked(inputs)
	if (locale === "de-DE") return de_de2_group_invitation_revoked(inputs)
	if (locale === "it-IT") return it_it2_group_invitation_revoked(inputs)
	return en_us2_group_invitation_revoked(inputs)
});
export { group_invitation_revoked as "group.invitation_revoked" }